<template class="full-height">
  <div class="socket-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      append-to-body
      modal-append-to-body
      :top="dialogTopMargin"
      :title="'Log Content'"
      :visible.sync="logContentDialogVisible"
      width="50%"
    >
      <el-input type="textarea" readonly :rows="22" :value="currentLogContent"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="logContentDialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      modal-append-to-body
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'Socket'"
      :visible.sync="socketsDialogVisible"
      width="50%"
      v-if="currentSockets"
    >
      <el-card class="box-card">
        <el-table
          v-if="currentSockets && currentSockets.length > 0"
          v-loading="listLoading"
          size="mini"
          :data="currentSockets"
          border
          fit
          highlight-current-row
          height="600px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="socketID" width="500">
            <template slot-scope="scope">
              <el-tag size="mini" type="danger">{{ scope.row.socketID }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="left" label="status" width="500">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.status == 'Open' ? 'success' : 'danger'">{{
                scope.row.status
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="socketsDialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      modal-append-to-body
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'Log'"
      :visible.sync="logDialogVisible"
      width="50%"
      v-if="currentLogs"
    >
      <el-card class="box-card">
        <el-table
          v-if="currentLogs && currentLogs.length > 0"
          v-loading="listLoading"
          size="mini"
          :data="currentLogs"
          border
          fit
          highlight-current-row
          height="600px"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="時間" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.dateTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="操作類型" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.messageType }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="內容" width="150">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="showLogContent(scope.row)"
                >內容</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="logDialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="80%"
      v-if="form"
    >
      <el-card class="box-card">
        <el-table
          v-if="form && form.usersInfo"
          v-loading="listLoading"
          size="mini"
          :data="form.usersInfo"
          border
          fit
          highlight-current-row
          height="100%"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="領隊" width="50">
            <template slot-scope="scope">
              <span style="font-size: 20px; color: red" v-if="scope.row.isLeader">*</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="上線" width="50">
            <template slot-scope="scope">
              <span style="font-size: 20px; color: green" v-if="scope.row.isOnline">*</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="帳號" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.userAccount }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="姓名" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="連線時間" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.startDate }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="socketIDs" width="150">
            <template slot-scope="scope">
              <el-button @click="getSocketIDs(scope.row)" size="mini" type="success"
                >{{ getSocketStatus(scope.row.sockets, 'Open') }}
              </el-button>
              <el-button @click="getSocketIDs(scope.row)" size="mini" type="danger"
                >{{ getSocketStatus(scope.row.sockets, 'Closed') }}
              </el-button>
            </template>
          </el-table-column>

          <el-table-column align="center" label="logs" width="150">
            <template slot-scope="scope">
              <el-button size="mini" type="info" @click="getLogs(scope.row)">{{
                scope.row.logs.length
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <!-- <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="團ID" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.travel">{{ scope.row.travel.travelID }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="團號" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.roomName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="團名" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.travel">{{ scope.row.travel.travelName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅客人數" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.travel">{{ scope.row.travel.touristsCount }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="查看" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { getViewPoints, saveViewPoint } from '@/api/travel'
import { getSocketInfo } from '@/api/socketApi'
var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'SocketInfo',
  components: {
    Pagination,
  },
  data() {
    return {
      currentLogContent: null,
      logContentDialogVisible: false,
      currentLogs: [],
      currentSockets: [],
      logDialogVisible: false,
      socketsDialogVisible: false,
      funcName: '旅遊團Socket狀態',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    this.form = defaultForm
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    getSocketStatus(sockets, status) {
      return sockets.filter(f => {
        return f.status == status
      }).length
    },
    getLogs(row) {
      this.currentLogs = row.logs
      this.logDialogVisible = true
    },
    getSocketIDs(row) {
      this.currentSockets = row.sockets
      this.socketsDialogVisible = true
    },
    showLogContent(c) {
      this.currentLogContent = c.msg
      this.logContentDialogVisible = true
    },
    addData() {
      this.dialogVisible = true
    },
    editData(row) {
      this.form = row
      console.log(this.form)
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.funcName}}】資料?`)) {
        return
      }

      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          let resp = await saveViewPoint(this.form)
          await vm.getList()
          this.dialogVisible = false
          vm.dialogLoading = false
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getSocketInfo(this.listQuery)
      console.log(resp)
      this.list = resp.data
      this.total = resp.data.length
      this.listLoading = false
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
